import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

export interface TopicCreatePayload {
  name_eng: string;
  name_hindi?: string;
  parent_topic_id: string;
  item_level: number;
}

export interface TopicRenamePayload {
  name_eng?: string;
  name_hindi?: string;
}

@Injectable({
  providedIn: 'root'
})
export class TreeEditService {
  private apiBaseUrl = `${environment.apiBaseUrl}/api`;

  constructor(private http: HttpClient) {}

  /**
   * Create a new topic
   */
  createTopic(payload: TopicCreatePayload): Observable<any> {
    console.log('Creating topic with payload:', payload);
    // Validate required fields
    if (!payload.name_eng) {
      console.error('Missing required field: name_eng');
    }
    if (!payload.parent_topic_id) {
      console.error('Missing required field: parent_topic_id');
    }
    if (!payload.item_level || payload.item_level <= 0) {
      console.error('Missing or invalid required field: item_level');
    }

    return this.http.post(`${this.apiBaseUrl}/topics`, payload);
  }

  /**
   * Rename a topic
   */
  renameTopic(topicId: string, payload: TopicRenamePayload): Observable<any> {
    return this.http.put(`${this.apiBaseUrl}/topics/${topicId}`, payload);
  }

  /**
   * Delete a topic
   */
  deleteTopic(topicId: string): Observable<any> {
    return this.http.delete(`${this.apiBaseUrl}/topics/${topicId}`);
  }
}
